import { Codecs, } from "../types.js";
import { BaseCodec } from "./base-codec.js";
export class NoneCodec extends BaseCodec {
    static get = (definition) => {
        return new NoneCodec();
    };
    encodingConverter;
    decodingConverter;
    constructor() {
        super();
        this.encodingConverter = undefined;
        this.decodingConverter = undefined;
    }
    setUnit(targetUnit, sourceUnit) {
        this.encodingConverter = targetUnit.getConverter(sourceUnit);
        this.decodingConverter = sourceUnit.getConverter(targetUnit);
        return this;
    }
    encode(decodedValue) {
        return this.encodingConverter ? [decodedValue != null ? this.encodingConverter.convert(decodedValue) : null] : super.encode(decodedValue);
    }
    _decode(encodedValue) {
        return this.decodingConverter ? this.decodingConverter.convert(encodedValue) : super._decode(encodedValue);
    }
    getDefinition() {
        return {
            id: Codecs.NONE,
        };
    }
    toString() {
        return JSON.stringify(this.getDefinition());
    }
}
